// ** Navigation imports
import masters from './masters'
import users from './users'
import roles from './roles'
import pages from './pages'
import vehicle from './vehicle'
import dashboards from './dashboards'
import personalInformation from './pis-individual'
import vehicleCrashData from './vehicle-crash-data'
import learnerLicenseDetails from './learner-license'
import offence from './offence'
import drivingLicense from './driving-license'
import drivingTest from './driving-test'
import report from './report'
import payment from './payment'
import chargeCalculator from './charge-calculator'
import passengerBus from './passenger-bus'
import announcements from './announcements'
import configurations from './configurations'

// ** Merge & Export
export default [...dashboards, ...chargeCalculator, ...personalInformation, ...offence, ...vehicle, ...learnerLicenseDetails, ...drivingTest, ...drivingLicense, ...users, ...announcements, ...roles, ...masters, ...payment, ...vehicleCrashData, ...report, ...passengerBus, ...configurations, ...pages]
